import { render, staticRenderFns } from "./AnnouncementsRail.vue?vue&type=template&id=72c2790f&scoped=true&"
import script from "./AnnouncementsRail.vue?vue&type=script&lang=js&"
export * from "./AnnouncementsRail.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementsRail.vue?vue&type=style&index=0&id=72c2790f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c2790f",
  null
  
)

export default component.exports